<r1-compass-lib-instructions headerText="Talking Points">
    Use the editor below to create the content that should be written to the Talking Points field on your Recommendation
    Object in Salesforce. You can personalize this content with Eloqua Custom Object Fields or Salesforce Fields by
    dragging the field merges into the editor.
</r1-compass-lib-instructions>

<form [formGroup]="form" (ngSubmit)="onSave()">
    <r1-compass-app-content-editor
        [editorContentType]="'play'"
        [assetId]="playId()!"
        [froalaContentFormControl]="form.controls.froalaContentFormControl"
        [fileImporterHeaders]="play()?.config?.playFileImport?.headers ?? []"
        [showErrors]="true"
        (fieldMergeDeleted)="trueUpLookupFieldMappings()" />
    @if (form.controls.froalaContentFormControl.errors?.['invalidContentAssets']; as invalidContentAssets) {
        <div style="color: orange">
            Your talking points uses the following invalid content assets:
            {{ invalidContentAssets.assetNames.join(', ') }}
        </div>
    }

    @if (isPlayImporter()) {
        <div class="lookup-field-mapping">
            <r1-compass-lib-instructions headerText="Merge Field Lookup">
                Some merge fields require additional information. Map each lookup field to the corresponding column in
                your import file. These mappings are used to populate generic merge fields (account-specific,
                lab-specific, etc.).
            </r1-compass-lib-instructions>
            <div class="lookup-field-mapping-list-container">
                @for (
                    mappingFormGroup of form.controls.playImporterLookupFieldMappings.controls;
                    track mappingFormGroup
                ) {
                    <r1-compass-lib-field-mapping [index]="0" [totalRequiredRows]="0" [rowOptionButtons]="[]">
                        <r1-compass-lib-field-row [fieldRowWidth]="8">
                            <r1-compass-lib-field-field [fieldWidth]="4">
                                <mat-form-field>
                                    <mat-label>Lookup Field Name</mat-label>
                                    <mat-select [formControl]="mappingFormGroup.controls.lookupFieldName">
                                        <mat-option [value]="mappingFormGroup.controls.lookupFieldName.value"
                                            >{{ mappingFormGroup.controls.lookupFieldName.value }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </r1-compass-lib-field-field>
                            <r1-compass-lib-field-field [fieldWidth]="4">
                                <mat-form-field>
                                    <mat-label>CSV Field</mat-label>
                                    <mat-select [formControl]="mappingFormGroup.controls.fileHeaderName">
                                        @for (headerName of playImporterFileHeaders(); track $index) {
                                            <mat-option [value]="headerName">{{ headerName }}</mat-option>
                                        }
                                    </mat-select>
                                    @if (mappingFormGroup.controls.fileHeaderName.hasError('required')) {
                                        <mat-error>Field is required</mat-error>
                                    }
                                </mat-form-field>
                            </r1-compass-lib-field-field>
                        </r1-compass-lib-field-row>
                    </r1-compass-lib-field-mapping>
                } @empty {
                    <div class="no-data-view">(no lookup fields to map)</div>
                }
            </div>
        </div>
    }
    <div class="component-footer">
        <button class="button button-brilliant-blue" type="submit" [disabled]="disableSave()">Save</button>
    </div>
</form>
